'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _popup = require('./popup');

var _popup2 = _interopRequireDefault(_popup);

var _loading = require('./loading');

var _loading2 = _interopRequireDefault(_loading);

var _message = require('./message');

var _message2 = _interopRequireDefault(_message);

var _tip = require('./tip');

var _tip2 = _interopRequireDefault(_tip);

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Overlay = (_temp = _class = function (_Component) {
  _inherits(Overlay, _Component);

  function Overlay() {
    _classCallCheck(this, Overlay);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Overlay.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    this.manager = this.props.manager;
    this.manager.onItemsChange(function () {
      return _this2.forceUpdate();
    });
  };

  Overlay.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false;
  };

  Overlay.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.mask) {
      document.documentElement.classList.add('engine-blur');
    } else {
      document.documentElement.classList.remove('engine-blur');
    }
  };

  Overlay.prototype.render = function render() {
    var _this3 = this;

    var items = this.manager.getItems().map(function (item) {
      var props = item.getConfig();
      var type = item.getType();
      switch (type) {
        case 'alert':case 'confirm':case 'modal':case 'popup':
          return _react2.default.createElement(_popup2.default, _extends({}, props, { key: item.getId(), handle: item }));
        case 'loading':
          return _react2.default.createElement(_loading2.default, _extends({}, props, { key: item.getId(), handle: item }));
        case 'info':case 'success':case 'error':case 'warn':
          return _react2.default.createElement(_message2.default, _extends({}, props, { key: item.getId(), handle: item }));
        case 'tip':
          return _react2.default.createElement(_tip2.default, { key: item.getId(), handle: item });
        default:
          return null;
      }
    });

    return _react2.default.createElement(
      'div',
      null,
      this.manager.isShowMask() && _react2.default.createElement('div', { ref: function ref(_ref) {
          _this3.mask = _ref;
        }, className: 've-mask' }),
      items
    );
  };

  return Overlay;
}(_react.Component), _class.propTypes = {
  manager: _react.PropTypes.object
}, _temp);
exports.default = Overlay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-popups@4.2.3@@ali/ve-popups/build/overlay.js
// module id = 284
// module chunks = 0